import { useOutletContext } from "react-router-dom";
import type { VisibleModules } from "../hooks/useVisibleModules";

export type ShellContext = VisibleModules;

/** Modules visible to the user, loaded once by the shell (for pages like the overview). */
export function useShellContext(): ShellContext {
  return useOutletContext<ShellContext>();
}
